var shippingAddresses = [];
const postcodeRegexes = [];
countryList.forEach(country => {
    postcodeRegexes[country.abbrev] = country.postal;
});

const languages = [
    "English",
    "Chinese",
    "Danish",
    "Dutch",
    "French",
    "German",
    "Italian",
    "Japanese",
    "Norwegian",
    "Spanish",
    "Swedish"
];

const addressElements = [
    "firstname",
    "lastname",
    "address1",
    "address2",
    "city",
    "state",
    "country",
    "postcode"
];

const checkoutAddressElements = {
    firstname: "first_name",
    lastname: "last_name",
    address1: "address1",
    address2: "address2",
    city: "city",
    state: "province",
    country: "country",
    postcode: "zip"
}

const addressElementKeys = addressElements.concat(["key"]);


function equalsIgnoringCase(text, other) {
    return text.localeCompare(other, undefined, {sensitivity: 'base'}) === 0;
}

function isMultiShippingEnabled() {
    const box = document.getElementById("ship-to-multiple-addresses_checkbox");
    return box && box.checked;
}

async function updateMultipleShippingEnable() {
    const enabled = isMultiShippingEnabled();
    console.log("shipping enabled=" + enabled);
    try {
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
            body: JSON.stringify({
                attributes: {enable_multiple_shipping: enabled ? "enabled" : "disabled"}
            })
        });
        // now trigger a cart reload.
        window.location.reload();
    } catch (e) {
        console.log(e);
    }
}

function camelCase(name, delim = '-') {
    const list = Array.isArray(data) ? data : data.split(delim)
    return list.reduce((res, cur) => res + cur.charAt(0)
        .toUpperCase() + cur.slice(1)
    )
}


function compareAddress(map1, map2) {
    if (map1 === map2)
        return true;
    if (!map1 || !map2)
        return false;
    return addressElements.reduce((running, key) => {
        if (map2[key] !== map1[key])
            return false;
        return running;
    }, true);
}

/**
 * GEt an element for a shipping address item.
 * @param key   The element key. The id is prefixed by 'new-shipping-'
 */
function addressElement(key) {
    return document.getElementById(`new-shipping-${key}`);
}

function showAddressError(msg) {
    const elem = addressElement("error");
    elem.innerText = msg;
}

/**
 * Get an <option> element
 * @param value     The value of the option
 * @param text      Visible text
 * @param selected  Either true if selected, or the value string that should be selected
 */
function getOption(value, text, selected) {
    const option = document.createElement("option");
    option.value = value;
    option.innerText = text;
    if (selected === true || selected === value)
        option.selected = true;
    return option;
}

function modalAddressShow(show, forId) {
    const modal = document.getElementById("shipping-modal");
    showAddressError("");
    if (show) {
        const button = document.getElementById("address-save");
        button.dataset.forId = forId;
        const countrySelector = addressElement('country');
        if (countrySelector.childElementCount === 0) {
            countrySelector.innerText = "";
            countrySelector.appendChild(getOption("", "Select country", true));
            countryList.forEach(country => {
                const option = getOption(country.abbrev, country.name, false);
                option.dataset.postcodeRegex = country.postal;
                countrySelector.appendChild(option);
            });
        }
        addressElements.forEach(item => {
            const element = addressElement(item);
            element.classList.remove("new-shipping-error");
            if (item !== "country")     // retain country selection
                element.value = "";
        });
        modal.style.display = "block";
        modal.style.animation = "fadeIn 0.5s";
        document.getElementById("new-shipping-firstname").focus();
    } else {
        modal.style.display = "none";
    }
}

function updateSelectedCountry(value) {
    const label = document.getElementById("new-shipping-country-label");
    req = !!postcodeRegexes[value] ? " (required)" : "";
    label.innerText = value === "US" ? "Zipcode (required)" : `Postcode${req}`;
}

var forceSave = false;      // allow forced save over bad postcode.
function getNewAddress() {
    let valid = true;
    ['country', 'city', 'address1', 'lastname'].forEach(item => {
        const elem = addressElement(item);
        if (elem.value.trim() === "") {
            valid = false;
            elem.classList.add("new-shipping-error");
        } else
            elem.classList.remove("new-shipping-error");
    })
    const postcode = addressElement('postcode');
    const country = addressElement('country');
    postcode.classList.remove("new-shipping-error");
    if (country.value) {
        const regex = postcodeRegexes[country.value];
        if (typeof regex != 'undefined') {
            regex.lastIndex = 0;
            if (!regex.test(postcode.value)) {
                postcode.classList.add("new-shipping-error");
                // only fail on postcode mismatch the first time around, since we can't be 100 sure that our
                // validation is correct worldwide.
                if (valid && !forceSave) {
                    valid = false;
                    forceSave = true;
                }
            }
        }
    }
    if (!valid)
        return null;

    const address = {};
    addressElements.forEach(item => {
        address[item] = addressElement(item).value;
    });
    address.key = addressHash(address);
    return address;
}

function readableAddress(address) {
    let str = `${address.firstname} ${address.lastname},${address.address1} ${address.address2},${address.city} ${address.postcode} ${address.country}`;
    str = str.replaceAll("  ", " ")
    str = str.replaceAll(",,", ",")
    return str.trim();
}

function hashcode(stringval) {
    let hash = 0, i, chr;
    for (i = 0; i !== stringval.length; i++) {
        chr = stringval.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

function addressHash(address) {
    return new Date().getTime().toString() + hashcode(readableAddress(address)).toString();
}

function updateAddressElements() {
    const elems = document.getElementsByClassName("cert-shipping-address");
    for (const elem of elems) {
        elem.innerText = "";
        let value = elem.dataset.value;
        if (!value)
            value = "default";
        elem.appendChild(getOption("default", "Ship to address provided in checkout"));
        elem.appendChild(getOption("addnew", "Add a new shipping address"));
        shippingAddresses.forEach(addr => {
            elem.appendChild(getOption(addr.key, readableAddress(addr)));
        });
        elem.value = value;
    }
}

async function retrieveShippingAddresses() {
    let data = "[]";
    const dataHolder = document.getElementById("shipping-data-holder");
    if (!dataHolder)
        console.log("Did not find data-holder");
    else if (dataHolder.dataset.shippingAddresses)
        data = dataHolder.dataset.shippingAddresses;
    shippingAddresses = JSON.parse(data);
    updateAddressElements();
    await updateAllLineItemData();
}

async function modalAddressSave(forId) {
    try {
        let newAddress = getNewAddress();
        if (!newAddress) {
            showAddressError("Invalid address");
            return;
        }
        modalAddressShow(false);
        let same = false;
        shippingAddresses.forEach(address => {
            if (compareAddress(address, newAddress)) {
                same = true;
                newAddress = address;
            }
        });
        if (!same) {
            shippingAddresses.push(newAddress);
            await fetch('/cart/update.js',
                {
                    method: 'POST',
                    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
                    body: JSON.stringify(
                        {
                            attributes: {shippingAddresses: JSON.stringify(shippingAddresses)}
                        })
                });
        }
        console.log(newAddress);
        if (forId) {
            const element = document.getElementById(forId);
            element.dataset.value = newAddress.key;
            updateAddressElements();
            await updateLineItemData(element.dataset.lineIndex);
        } else
            updateAddressElements();
    } catch (e) {
        console.log(e);
    }
}

/**
 * Save properties for a line item.
 * @param lineIndex The 1-based line item index
 * @returns {Promise<void>}
 */
async function updateLineItemData(lineIndex) {
    busyButtons(true);
    const elems = document.getElementsByClassName("item-data");
    const properties = {};
    const dataElem = document.getElementById(`line-item-properties-${lineIndex}`);
    if (dataElem && dataElem.dataset.isRenewal) {
        properties.isRenewal = true;
        properties.renewalOrder = dataElem.dataset.renewalOrder;
    }
    let quantity = 1;
    for (const elem of elems) {
        if (elem.dataset.lineIndex === lineIndex.toString()) {
            const propname = elem.dataset.property;
            const index = parseInt(elem.dataset.index) - 1;
            if (typeof (properties[propname]) === 'undefined')
                properties[propname] = [];
            properties[propname][index] = elem.value;
            if (index + 1 > quantity)
                quantity = index + 1;
        }
    }
    if (properties.certificateShippingAddress)
        properties.shippingCountry = properties.certificateShippingAddress.map(addr => {
            if (!addr || addr === "default")
                return "default";
            return shippingAddresses.filter(a => {
                return a.key === addr;
            })[0].country;
        });
    const body = {
        line: lineIndex,
        properties: properties,
        quantity: quantity
    };
    // this should trigger a re-render
    properties.isMultiShippingEnabled = isMultiShippingEnabled();
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems)
        body.sections = [cartItems.dataset.id];
    console.log(properties);
    try {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
            body: JSON.stringify(body)
        });
    } catch (e) {
        console.log(e);
    }
    busyButtons(false);
}

async function updateAllLineItemData() {
    for (const elem of document.getElementsByClassName("line-item-index-holder")) {
        if (elem.dataset.lineIndex)
            await updateLineItemData(elem.dataset.lineIndex);
    }
}

function updateCertificateShippingAddress(select) {
    if (select.value === "addnew") {
        modalAddressShow(true, select.id);
        select.value = "default";
    } else
        updateLineItemData(select.dataset.lineIndex);
}

function getFormField(form, name) {
    for (const elem of form.elements) {
        if (elem.tagname === "input" && elem.name === name)
            return elem;
    }
    return null;
}

function busyButtons(state) {
    console.log(`busyButtons(${state}`);
    const buttons = document.getElementsByClassName("checkout-loading");
    for (const button of buttons) {
        if (state)
            button.classList.add("running");
        else
            button.classList.remove("running");
    }
}

/**
 * Called on form submission. Return true if we are good to go to the checkout.
 */
async function validateAdoptionsData() {
    const messages = document.getElementsByClassName("cart-validation-error");
    const elements = document.getElementsByClassName("item-data");
    let firstError = null;
    let count = 0;
    for (const element of elements) {
        if (element.classList.contains("form-required")) {
            if (!element.value) {
                if (!firstError)
                    firstError = element;
                element.classList.add("adoption-options-error");
                count++;
            } else
                element.classList.remove("adoption-options-error");
        }
    }
    if (!firstError) {
        for (const msg of messages) {
            msg.innertext = "";
        }
        await updateAllLineItemData();
        busyButtons(true);
        const form = document.getElementById("cart");
        if (!form) {
            console.log("Form not found");
            return false;
        }
        form.submit();
        return true;
    }
    const text = count === 1 ? "1 field requires completion" : `${count} fields require completion`
    for (const msg of messages) {
        msg.innerText = text;
    }
    const y = firstError.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 2;

    window.scrollTo(
        {
            top: y,
            left: 0,
            behavior: 'smooth'
        }
    );
}

function afterCartReload() {
    updateCartCountCookie();
    retrieveShippingAddresses();
}

// set a cookie on the parent domain so that the cart count can be displayed on other sites
function updateCartCountCookie() {
    const dataHolder = document.getElementsByClassName("checkout-form")[0];
    var itemCount = 0;
    if (dataHolder && dataHolder.dataset.itemCount) {
        itemCount = dataHolder.dataset.itemCount;
    }
    setCookie("kh_cart_item_count", itemCount, 30, parentDomain((location.hostname)));
}

window.addEventListener("DOMContentLoaded", () => {
    afterCartReload();
    document.addEventListener("cart:rerendered", () => {
        afterCartReload();
    });
    const modal = document.getElementById("shipping-modal");
    if (modal) {
        window.addEventListener("click", e => {
            if (e.target === modal) {
                modal.style.display = "none"
            }
        });
        window.addEventListener("keyup", event => {
            if (event.key === "Escape" || event.key === "Esc")
                modal.style.display = "none"
        });
    }
});
